import axios from 'axios';

const oktonBankApi = axios.create({
  baseURL: process.env.REACT_APP_OKTONBANK_API_URL,
  headers: { Accept: 'application/json' },
});

export default oktonBankApi;
